import * as DatepickerActions from '../actions/datepickers';
import * as FindUserActions from '../actions/findUser';
import * as CommunicationCreators from './communication';

import ReduxAction from '../interfaces/ReduxAction';

export function communicationMountTab (): ReduxAction {
  return (dispatch): void => {
    dispatch(DatepickerActions.fetchDatepickersShowAction());
    dispatch(FindUserActions.fetchActiveTabAction(2));
    dispatch(CommunicationCreators.communication());
  };
}
